<div class="px-15">

    <!-- Quick Actions -->
    <section id="quick-actions" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">Quick Actions</div>
                </div>
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'action-button'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">

                <!-- Add Stock -->
                <div class="action-button" (click)="addStock()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>add_box</mat-icon>
                    </div>
                    <span>Add Lab Stock</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <!-- View Test Requests -->
                <div class="action-button" (click)="goToTestRequests()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>biotech</mat-icon>
                    </div>
                    <span>View Test Requests</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

            </div>
        </div>
    </section>


    <!-- Assigned Tasks -->
    <section id="tasks-section" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">My Assigned Tasks</div>
                </div>
                <div class="subtitle">Tasks assigned to you that are active or ready</div>
            </div>
        </div>

        <div class="section-wrapper pt-30">
            <mat-card class="py-20">
                <mat-card-header>
                    <mat-card-title>Tasks</mat-card-title>
                    <mat-card-subtitle>Find and fulfill tasks assigned to you</mat-card-subtitle>
                </mat-card-header>

                <mat-card-content class="my-12">
                    <mat-divider></mat-divider>

                    @if (isLoadingTasks) {
                    <div class="g-just-flex" style="justify-content: center; padding: 40px;">
                        <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
                    </div>
                    } @else if (tasks.length === 0) {
                    <app-empty-state icon="task_alt" title="No tasks assigned"
                        subtitle="You have no active or ready tasks assigned to you at this time.">
                    </app-empty-state>
                    } @else {
                    <table mat-table matSort [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

                        <!-- Type column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef>Type</th>
                            <td mat-cell *matCellDef="let element">
                                {{ (element?.focus | references2) || (element?.code?.text) || 'N/A' }}
                            </td>
                        </ng-container>

                        <!-- For (patient) column -->
                        <ng-container matColumnDef="for">
                            <th mat-header-cell *matHeaderCellDef>Patient</th>
                            <td mat-cell *matCellDef="let element; let i = index;" #td class="restrict-width">
                                <div class="g-just-flex gap-0 my-12 link-group"
                                    style="justify-content: flex-start; align-items: center;">
                                    <div class="g-just-flex gap-5 link-group-words"
                                        style="justify-content: flex-start; align-items: flex-start; flex-direction: column;">
                                        <div class="top">
                                            {{ element.for | references2 }}
                                        </div>
                                        @if (isLinkObj['for']?.get(i) && element.for?.reference &&
                                        !element.for?.display) {
                                        <div class="bottom subtitle-text-color-2">
                                            @if ((element.for | fetchFromReference : 'name' : 0 : 'family') | async) {
                                            {{ element.for | fetchFromReference : 'name' : 0 : 'family' | async }}
                                            } @else {
                                            <mat-progress-spinner mode="indeterminate"
                                                style="width:10px; height:10px;"></mat-progress-spinner>
                                            }
                                        </div>
                                        }
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Status column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                @if (statusStyles[element.status]) {
                                <div
                                    [attr.class]="'small-chips status-' + statusStyles[element.status]['color'] + ' g-just-flex gap-8'">
                                    <span>{{ element.status }}</span>
                                    <mat-icon>{{ statusStyles[element.status]['icon'] }}</mat-icon>
                                </div>
                                } @else {
                                <span>{{ element.status }}</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Actions column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let element">
                                <mat-icon [mat-menu-trigger-for]="taskMenu">more_vert</mat-icon>
                                <mat-menu #taskMenu="matMenu" class="action-menu">
                                    <a (click)="showTask(element)">
                                        <span>View Details</span>
                                        <mat-icon>chevron_right</mat-icon>
                                    </a>
                                </mat-menu>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: tableColumns" (click)="showTask(row)"></tr>
                    </table>
                    }
                </mat-card-content>
            </mat-card>
        </div>
    </section>


    <!-- Appointments -->
    <section id="appointments-summaries" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">Appointments</div>
            </div>
        </div>
        <app-appointment-ui></app-appointment-ui>
    </section>

</div>